<template>
  <div id="app">
  	<keep-alive>
    	<router-view v-if="$route.meta.keepAlive" />
    </keep-alive>
    <router-view v-if = "!$route.meta.keepAlive" />
  </div>
</template>

<script>
export default {
  name: 'App',
  methods: {
  },
}
</script>

<style>
.rBtn{position:fixed;width:80px;height:86px;z-index:100;bottom:60px;left:10px;background:url('../static/image/back.png') no-repeat center center;background-size:80px}

</style>



// WEBPACK FOOTER //
// src/App.vue